/**
 * @generated SignedSource<<1c208618a5cce9d005f794110e0e105c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccountMessage_transaction$data = {
  readonly isPrivateOffer: boolean | null;
  readonly isShippingKnownAtCheckout: boolean | null;
  readonly " $fragmentType": "CheckoutBankAccountMessage_transaction";
};
export type CheckoutBankAccountMessage_transaction$key = {
  readonly " $data"?: CheckoutBankAccountMessage_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountMessage_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccountMessage_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivateOffer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isShippingKnownAtCheckout",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "0fa10657630e68ff6f0dfc8331cab54c";

export default node;
